module.exports = __webpack_public_path__ + "c36b5ac7c2dddf6f525c8d161412ef41.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/BoldItalic/OpenSans-BoldItalic.ttf?v=1.1.0
// module id = 1010
// module chunks = 0